import React, { useMemo, useState } from 'react';
import { usePoll } from '../../hooks/usePoll';
import {
  Avatar,
  Button,
  LinearProgress,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import {
  convertToInternationalCurrencySystem,
  fetchDerivatives,
  fetchDerivativesPrice,
  logoWrapper
} from '../../utils';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  ArrowDownward,
  ArrowUpward,
  StarOutline,
  ArrowForward,
  FiberManualRecord
} from '@mui/icons-material';
// import { MenuData } from '../../components/Tables/menuData';
import { useEffect } from 'react';
import * as actionTypes from '../../store/actionTypes';
import EditToken from '../../screens/editToken';
import CommonMenu from '../../components/commonMenu/commonMenu';
import Transactions from '../Transactions/transaction.table';
import TokenChart from '../../components/coinInfo/tokenChart';
import TokenTable from '../../components/Tables/TokenTable/token.table';
import MarketStats from '../../components/MarketStats/MarketStats';
import { useTokenListing, ListingFooter } from '../../hooks/useTokenListing';
function getFormattedTime(timestampString) {
  const timestamp = new Date(timestampString);

  timestamp.setHours(timestamp.getHours());
  return timestamp;
}
const RedSwapBtn = {
  display: 'flex',
  width: '119px',
  height: '36px',
  padding: '10px 19px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  borderRadius: '30px',
  border: '1px solid #F93C3C',
  flexShrink: 0,
  color: '#F93C3C',
  textAlign: 'center',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '100%',
  marginTop: '-20px'
};
const NormalSwapBtn = {
  display: 'flex',
  width: '119px',
  height: '36px',
  padding: '10px 19px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  borderRadius: '30px',
  border: '1px solid #34D399',
  flexShrink: 0,
  color: '#34D399',
  textAlign: 'center',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '100%',
  marginTop: '-20px'
};
const CryptoPairTable = () => {
  const { derivatives, loading, isAdmin, PecuPrice, derivativesPrice } =
    useSelector(
      (state) => ({ derivatives: state.derivatives, loading: state.loading, isAdmin: state.isAdmin, PecuPrice: state.PecuPrice, derivativesPrice: state.derivativesPrice }),
      shallowEqual
    );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [blinkUpList, setBlinkUpList] = useState([]);
  const [blinkDownList, setBlinkDownList] = useState([]);

  const [open, setOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState({});
  const [priceList, setPriceList] = useState([]);
  const [derivativePriceTick, setDerivativPrice] = useState(derivativesPrice);
  const [searchDerivatives, setSearchDerivatives] = useState('');
  // const [derivativesPage, setDerivativesPage] = useState(0);
  const [page, setPage] = useState(1);
  const disabled = ['USD/JPY'];
  const filterderivatives = (searchDerivatives) => {
    if (searchDerivatives && searchDerivatives !== '') {
      return derivatives?.tokens
        ?.filter(
          (e) =>
            !disabled.includes(e.symbol) &&
            (e.symbol.toLowerCase().includes(searchDerivatives.toLowerCase()) ||
              e.name.toLowerCase().includes(searchDerivatives.toLowerCase()))
        )
        ?.sort((a, b) => a.sort - b.sort);
    } else {
      return derivatives?.tokens
        ?.filter((e) => !disabled.includes(e.symbol))
        ?.sort((a, b) => a.sort - b.sort);
    }
  };

  // Whole list in one request; search/pagination happen client-side.
  usePoll(() => {
    fetchDerivatives(dispatch, actionTypes.FETCH_DERIVATIVES, 1, 500);
    return fetchDerivativesPrice(dispatch, actionTypes.FETCH_DERIVATIVES_PRICE, 1, 500);
  }, 5000, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const hybridRows = useMemo(() => filterderivatives(''), [derivatives]);

  useEffect(() => {
    // Compare current prices with the previous prices
    if (priceList.length > 0) {
      const updatedPriceList = Object.entries(derivativePriceTick)
        .filter(([token, price]) => {
          const prevPrice = priceList.find((item) => item.token === token);
          return prevPrice && prevPrice.price !== price;
        })
        .map(([token, price]) => ({ token, price }));

      if (updatedPriceList.length > 0) {
        const newBlinkUpList = updatedPriceList.filter((item) => {
          const prevPrice = priceList.find(
            (prevItem) => prevItem.token === item.token
          );
          return prevPrice && item.price > prevPrice.price;
        });

        const newBlinkDownList = updatedPriceList.filter((item) => {
          const prevPrice = priceList.find(
            (prevItem) => prevItem.token === item.token
          );
          return prevPrice && item.price < prevPrice.price;
        });

        setPriceList((prevPriceList) => [
          ...prevPriceList.filter(
            (item) =>
              !updatedPriceList.some(
                (updatedItem) => updatedItem.token === item.token
              )
          ),
          ...updatedPriceList
        ]);

        setBlinkUpList(newBlinkUpList.map((item) => item.token));
        setBlinkDownList(newBlinkDownList.map((item) => item.token));

        setTimeout(() => {
          setBlinkUpList([]);
          setBlinkDownList([]);
        }, 500);
      }
    } else {
      setPriceList(
        Object.entries(derivativesPrice).map(([token, price]) => ({
          token,
          price
        }))
      );
    }
  }, [derivativePriceTick, priceList]);

  useEffect(() => {
    setDerivativPrice(derivativesPrice);
  }, [derivativesPrice, derivativePriceTick]);
  // Search + pagination over the WHOLE list (see hooks/useTokenListing).
  const listing = useTokenListing(hybridRows, searchDerivatives);

  return (
    <div
      className="screen"
      style={{
        zIndex: '100',
        position: 'sticky',
        width: '100%',
        marginBottom: '1rem'
      }}
    >

      <div
        style={{
          width: '95%',
          minWidth: '340px'
        }}
        className="res-token"
      >
        <MarketStats />
        <CommonMenu label={'Hybrid'} setSearch={setSearchDerivatives} />
        <TokenTable
          loading={loading}
          token={listing.pageRows}
          blinkUpList={blinkUpList}
          blinkDownList={blinkDownList}
          href={'hybrid'}
          PecuPrice={PecuPrice}
          swappable={true}
          getFormattedTime={getFormattedTime}
          showPecu={false}
          priceData={derivativesPrice}
        />
        <ListingFooter
          listing={listing}
          loaded={Array.isArray(derivatives?.tokens)}
          noun="Hybrid tokens"
        />
        <Transactions />
      </div>
      <EditToken token={selectedToken} open={open} setOpen={setOpen} />
    </div>
  );
};

export default CryptoPairTable;
